import React from 'react'
import { drinkPackageVS } from 'services/validations/catalog/packages/drinkPackage'
import LinkedRulesPanel from 'ui-shared/LinkedRulesPanel'
import ProductPackageBaseFormProvider from '../ProductPackageBaseFormProvider'
import DrinkPresetAdditionalFields from './DrinkPresetAdditionalFields'

const DrinkPackageForm: React.FC = () => {
  return (
    <ProductPackageBaseFormProvider
      entity="drinks"
      isToggleBundleVisible
      defaultBundleSetting={false}
      validationSchema={drinkPackageVS}
      linkedRulesPanel={<LinkedRulesPanel />}
      presetInputFields={<DrinkPresetAdditionalFields />}
    />
  )
}

export default DrinkPackageForm
